import { render, staticRenderFns } from "./Tipos_productos.vue?vue&type=template&id=030b6316&scoped=true"
import script from "./Tipos_productos.vue?vue&type=script&lang=js"
export * from "./Tipos_productos.vue?vue&type=script&lang=js"
import style0 from "./Tipos_productos.vue?vue&type=style&index=0&id=030b6316&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030b6316",
  null
  
)

export default component.exports